import { Component, inject, signal } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../core/auth.service';
import { errorMessage } from '../core/http-error';

@Component({
  selector: 'app-crm-signin',
  imports: [ReactiveFormsModule],
  templateUrl: './crm-signin.html',
})
export class CrmSignInPage {
  private readonly auth = inject(AuthService);
  private readonly router = inject(Router);
  protected readonly submitting = signal(false);
  protected readonly serverError = signal<string | null>(null);

  protected readonly form = inject(FormBuilder).nonNullable.group({
    email: ['', [Validators.required, Validators.email]],
    password: ['', Validators.required],
  });

  constructor() {
    if (this.auth.staff()) {
      void this.router.navigateByUrl('/crm');
    }
  }

  protected submit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.submitting.set(true);
    this.serverError.set(null);
    const { email, password } = this.form.getRawValue();
    this.auth.login(email, password).subscribe({
      next: (response) => {
        const role = response.user.role;
        if (role !== 'ADMIN' && role !== 'AGENT') {
          this.auth.signOut();
          this.submitting.set(false);
          this.serverError.set('This sign-in is for admins and agents.');
          return;
        }
        void this.router.navigateByUrl('/crm');
      },
      error: (error: unknown) => {
        this.submitting.set(false);
        this.serverError.set(errorMessage(error, 'Could not sign in.'));
      },
    });
  }
}
